import React, { FunctionComponent, useState } from "react";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { InputBase, IconButton, Grid, Paper } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import { Helmet } from "react-helmet-async";
import { eodItemStyles } from "./eodItemStyles";
import { EodHomePage } from "./EodOldCode/EodHomePage";
import { useStore } from "../../store";
import { useEffect } from "react";
import { EodReportView } from "./EodReportData/EodReportView";
import { EodTableList } from "./EodReportData/EodTableList";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
type permissionType = {
  permission_id: number;
  is_add: boolean;
  is_edit: boolean;
  is_view: boolean;
  is_delete: boolean;
};
export const TabPanel: FunctionComponent<TabPanelProps> = ({
  children,
  value,
  index,
}) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      //   {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

export const EodMaster = () => {
  const classes = eodItemStyles();
  const [value, setValue] = React.useState(0);
  const [searchText, setSearchtext] = useState<string | null>("");
  const [searchFlag, setSearchFlag] = useState<boolean>(false);
  const [user] = useStore("auth", "user");
  const [createEodPermission, setCreateEodPermission] = useState<boolean>(
    false
  );
  const [viewEodPermission, setViewEodPermission] = useState<boolean>(false);
  useEffect(() => {
    const eodPermission = user.permissions.find(
      (permission: permissionType) => permission.permission_id === 3
    );

    if (user.is_super_admin === true) {
      setViewEodPermission(true);
      setCreateEodPermission(true);
    } else {
      if (eodPermission) {
        if (eodPermission.is_add === true) {
          setCreateEodPermission(true);
        }
        if (eodPermission.is_view === true) {
          setViewEodPermission(true);
        }
        // if (eodPermission.is_view === false) {
        //   setViewEodPermission(false);
        //   setValue(1)
        // }
        // if (eodPermission.is_add === false && eodPermission.is_view === false) {
        //   setViewEodPermission(false);
        //   setCreateEodPermission(false);

        // }
      }
    }
  });

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
    setSearchFlag(false);
  };

  const handleSearch = () => {
    setSearchFlag(true);
  };

  const goBackToMaster = () => {
    setValue(0);
  };

  return (
    <>
      <Helmet>
        <title>EOD</title>
      </Helmet>
      <div className={classes.root1}>
        <AppBar position="static">
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="simple tabs example"
          >
            <Tab
              label="Eod List"
              style={{ display: viewEodPermission ? "" : "none" }}
            />
            <Tab
              label="Create Eod"
              style={{ display: createEodPermission ? "" : "none" }}
            />
          </Tabs>
        </AppBar>
        <TabPanel value={value} index={0}>
          <Grid
            container
            spacing={2}
            direction="row"
            justify="space-between"
            alignItems="center"
          >
            {viewEodPermission ? (
              <Grid item xs={12}>
                <EodTableList handleSearch={handleSearch} />
              </Grid>
            ) : (
              ""
            )}
          </Grid>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <EodReportView goBackToMaster={goBackToMaster} />
        </TabPanel>
      </div>
    </>
  );
};
